import { UnberryApi } from "../config/request";

const OrganizationApi = {
  getMetrics() {
    return UnberryApi.safeCall(`/api/company/v1/:orgId/metrics`, "GET");
  },
};

export default OrganizationApi;